import {
  taskGroupsQuery,
  useDeleteTaskGroupMutation,
} from "@common/api/quoting/task-group"
import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { handleError } from "@common/utils"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"

export const Route = createFileRoute(
  "/_layout/settings/_panel/quoting/task-groups/$groupId/archive",
)({
  component: ArchiveTaskGroupDialog,
})

function ArchiveTaskGroupDialog(): React.ReactElement | null {
  const { groupId } = Route.useParams()
  const { data } = useSuspenseQuery(taskGroupsQuery({ deleted: false }))
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const archiveMutation = useDeleteTaskGroupMutation()
  const group = data.data.find((item) => item.id === groupId)

  if (!group) {
    return null
  }

  const close = () =>
    navigate({ to: "/settings/quoting/task-groups", search: true })

  const confirm = () =>
    archiveMutation.mutate(
      { group_id: groupId },
      {
        onSuccess: () => {
          showToast("Archived", `${group.name} archived.`, "success")
          close()
        },
        onError: (error) => handleError(error, showToast),
      },
    )

  return (
    <ConfirmDialog
      title={`Archive ${group.name}?`}
      description="Archived groups keep their history and appear in the Archived tab."
      action="Archive"
      tone="default"
      pendingAction="Archiving…"
      pending={archiveMutation.isPending}
      onConfirm={confirm}
      onCancel={close}
    />
  )
}
